import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const ChapterAdd = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="ChapterAdd" {...props}>
    <path d="M4 16C4.55228 16 5 16.4477 5 17V19H7C7.55228 19 8 19.4477 8 20C8 20.5523 7.55228 21 7 21H5V23C5 23.5523 4.55228 24 4 24C3.44772 24 3 23.5523 3 23V21H1C0.447715 21 0 20.5523 0 20C0 19.4477 0.447715 19 1 19H3V17C3 16.4477 3.44772 16 4 16Z" fill="#000" /><path fillRule="evenodd" clipRule="evenodd" d="M19 0C21.7614 0 24 2.23858 24 5V11C24 13.7614 21.7614 16 19 16C19 18.7614 16.7614 21 14 21H11C10.4477 21 10 20.5523 10 20C10 19.4477 10.4477 19 11 19H14C15.6569 19 17 17.6569 17 16V10C17 8.34315 15.6569 7 14 7H8C6.34315 7 5 8.34315 5 10V13C5 13.5523 4.55228 14 4 14C3.44772 14 3 13.5523 3 13V10C3 7.23858 5.23858 5 8 5C8 2.23858 10.2386 0 13 0H19ZM13 2C11.3431 2 10 3.34315 10 5H14C16.7614 5 19 7.23858 19 10V14C20.6569 14 22 12.6569 22 11V5C22 3.34315 20.6569 2 19 2H13Z" fill="#000" />
  </StyledIcon>
));

ChapterAdd.displayName = 'ChapterAdd';

export { ChapterAdd };
